import React, { useState } from 'react';
import styled from 'astroturf/react';

import ExpandLessIcon from 'js/design_system/icons/expand_less.svg';
import _SectionWrapper from "Accordion-SectionWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/Accordion.tsx?styleId=SectionWrapper";
import _SectionTitle from "Accordion-SectionTitle.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/Accordion.tsx?styleId=SectionTitle";
import _ExpandIcon from "Accordion-ExpandIcon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/Accordion.tsx?styleId=ExpandIcon";
import _SectionTitleText from "Accordion-SectionTitleText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/Accordion.tsx?styleId=SectionTitleText";
import _SectionContents from "Accordion-SectionContents.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/Accordion.tsx?styleId=SectionContents";
import _SectionsWrapper from "Accordion-SectionsWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/Accordion.tsx?styleId=SectionsWrapper";


type Section = {
  title: string | React.ReactNode;
  contents: React.ReactNode;
  defaultOpen?: boolean;
};

type AccordionProps = {
  sections: Section[];
  style?: React.CSSProperties;
};

type AccordionSectionProps = {
  section: Section;
  open: boolean;
  onToggle: () => void;
  style?: React.CSSProperties;
};

const SectionWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "SectionWrapper",
  styles: _SectionWrapper
});

const SectionTitle = /*#__PURE__*/styled("button", null, {
  displayName: "SectionTitle",
  styles: _SectionTitle
});

const ExpandIcon = /*#__PURE__*/styled("div", null, {
  displayName: "ExpandIcon",
  styles: _ExpandIcon
});

const SectionTitleText = /*#__PURE__*/styled("div", null, {
  displayName: "SectionTitleText",
  styles: _SectionTitleText
});

const SectionContents = /*#__PURE__*/styled("div", null, {
  displayName: "SectionContents",
  styles: _SectionContents
});

const SectionsWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "SectionsWrapper",
  styles: _SectionsWrapper
});

export const AccordionSection: React.FC<AccordionSectionProps> = ({
  section,
  open,
  onToggle,
  style,
}) => {
  return (
    <SectionWrapper style={style}>
      <SectionTitle onClick={onToggle}>
        {typeof section.title === 'string' ? (
          <SectionTitleText>{section.title}</SectionTitleText>
        ) : (
          section.title
        )}
        <ExpandIcon open={open}>
          <ExpandLessIcon />
        </ExpandIcon>
      </SectionTitle>
      {open && <SectionContents>{section.contents}</SectionContents>}
    </SectionWrapper>
  );
};

export const Accordion: React.FC<AccordionProps> = ({ sections, style }) => {
  const [openSections, setOpenSections] = useState<boolean[]>(() =>
    sections.map((section) => !!section.defaultOpen),
  );

  function toggleIndex(i: number) {
    setOpenSections((prev) => {
      const next = [...prev];
      next[i] = !next[i];
      return next;
    });
  }

  return (
    <SectionsWrapper style={style}>
      {sections.map((section, i) => (
        <AccordionSection
          key={`accordion-section-${i}`}
          open={openSections[i]}
          onToggle={() => toggleIndex(i)}
          section={section}
        />
      ))}
    </SectionsWrapper>
  );
};
